module.exports = __webpack_public_path__ + "static/media/asuka-win.6b2b22a4.png";